// extracted by mini-css-extract-plugin
export default {"mainContainer":"TermsAndCondition_mainContainer__pBLcV"};